"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { SearchIcon } from "lucide-react"
import { Input } from "@/components/ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export function StoreToolbar() {
  const router = useRouter()
  const sp = useSearchParams()

  const setParam = (key: string, value: string) => {
    const params = new URLSearchParams(sp.toString())
    if (value) params.set(key, value)
    else params.delete(key)
    router.push(params.toString() ? `/?${params.toString()}` : "/")
  }

  return (
    <div className="mb-5 flex flex-wrap items-center gap-3">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          const fd = new FormData(e.currentTarget)
          setParam("q", String(fd.get("q") || "").trim())
        }}
        className="relative min-w-[220px] flex-1"
      >
        <SearchIcon className="text-muted-foreground pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2" />
        <Input
          name="q"
          defaultValue={sp.get("q") || ""}
          placeholder="Tìm vũ khí..."
          className="pl-9"
        />
      </form>
      <Select
        value={sp.get("sort") || "default"}
        onValueChange={(v) => setParam("sort", v === "default" ? "" : String(v))}
      >
        <SelectTrigger className="w-[190px]">
          <SelectValue placeholder="Sắp xếp" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="default">Mặc định</SelectItem>
          <SelectItem value="price-asc">Giá: thấp → cao</SelectItem>
          <SelectItem value="price-desc">Giá: cao → thấp</SelectItem>
          <SelectItem value="rating">Đánh giá cao</SelectItem>
          <SelectItem value="name">Tên A → Z</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
